import { useTranslation } from "react-i18next";

import { skipToken, useQuery } from "@tanstack/react-query";

import { getFarmDocScanField } from "services";

import { GET_FARM_DOC_SCAN_FIELD } from "consts";

import { GetFarmDocScanFieldResponse } from "models";

export const useGetFarmDocScanField = ({ farmId, scanFieldId }: { farmId: string; scanFieldId: string | undefined }) => {
  // The API names the crops in the request language, so each language gets its own cache entry.
  const { i18n } = useTranslation(["practices"], { useSuspense: false });

  return useQuery<GetFarmDocScanFieldResponse>({
    queryKey: [GET_FARM_DOC_SCAN_FIELD, farmId, scanFieldId, i18n.language],
    queryFn: farmId && scanFieldId ? async () => getFarmDocScanField({ farmId, scanFieldId }) : skipToken,
    staleTime: 1000 * 60 * 5,
  });
};
